<ng-container *ngIf="isEnabled; else content">
  <div
    [class.fade-truncate]="isOverflowed()"
    appTextOverflowCheck
    [appTextOverflowCheckDisabled]="!isEnabled"
    (textOverflowed)="onTextOverflowed($event)"
    [matTooltip]="
      (tooltipPrefix !== null && tooltipPrefix !== undefined ? tooltipPrefix + ': ' : '') + (tooltip ?? text)
    "
    [matTooltipDisabled]="disableTooltip || isTooltipMode() === false">
    <ng-container *ngIf="customStyles; else noStyle">
      <div [ngStyle]="customStyles">
        <ng-container *ngIf="optionalTextPositionLeft">
          <span *ngIf="optionalText !== undefined && optionalText !== null" [ngStyle]="customOptionalStyles">
            {{ optionalText }}
          </span>
          {{ text }}
        </ng-container>
        <ng-container *ngIf="!optionalTextPositionLeft">
          {{ text }}
          <span *ngIf="optionalText !== undefined && optionalText !== null" [ngStyle]="customOptionalStyles">
            {{ optionalText }}
          </span>
        </ng-container>
      </div>
    </ng-container>

    <ng-template #noStyle>
      <ng-container *ngIf="optionalTextPositionLeft">
        <span *ngIf="optionalText !== undefined && optionalText !== null" [ngStyle]="customOptionalStyles">
          {{ optionalText }}
        </span>
        {{ text }}
      </ng-container>
      <ng-container *ngIf="!optionalTextPositionLeft">
        {{ text }}
        <span *ngIf="optionalText !== undefined && optionalText !== null" [ngStyle]="customOptionalStyles">
          {{ optionalText }}
        </span>
      </ng-container>
    </ng-template>
  </div>
</ng-container>

<ng-template #content>
  <ng-container *ngIf="optionalTextPositionLeft">
    <span *ngIf="optionalText !== undefined && optionalText !== null" [ngStyle]="customOptionalStyles">
      {{ optionalText }}
    </span>
    {{ text }}
  </ng-container>
  <ng-container *ngIf="!optionalTextPositionLeft">
    {{ text }}
    <span *ngIf="optionalText !== undefined && optionalText !== null" [ngStyle]="customOptionalStyles">
      {{ optionalText }}
    </span>
  </ng-container>
</ng-template>
